module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    staticStyle: {
      "min-width": "900px"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "26px",
      "display": "inline-block",
      "cursor": "pointer"
    }
  }, [_vm._v("应用详情")]), _vm._v(" "), _c('div', {
    staticClass: "formStyle"
  }, [_c('Form', {
    staticStyle: {
      "padding": "20px"
    },
    attrs: {
      "model": _vm.formItem,
      "label-width": 100
    }
  }, [_c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("应用Logo")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px",
      "height": "100px"
    },
    attrs: {
      "src": _vm.formItem.appLogo
    }
  })])], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品名称")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.productTitle),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productTitle", $$v)
      },
      expression: "formItem.productTitle"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("包名")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.packageName),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "packageName", $$v)
      },
      expression: "formItem.packageName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("Appid")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.appid),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "appid", $$v)
      },
      expression: "formItem.appid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品id")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.productId),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productId", $$v)
      },
      expression: "formItem.productId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("应用版本")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.appVersion),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "appVersion", $$v)
      },
      expression: "formItem.appVersion"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("上架时间")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": ""
    },
    model: {
      value: (_vm.formItem.time),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "time", $$v)
      },
      expression: "formItem.time"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("应用类别")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('RadioGroup', {
    model: {
      value: (_vm.formItem.appCategory),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "appCategory", $$v)
      },
      expression: "formItem.appCategory"
    }
  }, [_c('Radio', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("启明应用")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("启明游戏")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "3",
      "disabled": ""
    }
  }, [_vm._v("其他应用")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "4",
      "disabled": ""
    }
  }, [_vm._v("其他游戏")]), _vm._v(" "), _c('Radio', {
    attrs: {
      "label": "5",
      "disabled": ""
    }
  }, [_vm._v("未分类")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品简介")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "type": "textarea"
    },
    model: {
      value: (_vm.formItem.productShortDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productShortDescribe", $$v)
      },
      expression: "formItem.productShortDescribe"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("产品详情")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('Input', {
    attrs: {
      "readonly": "",
      "type": "textarea",
      "autosize": {
        minRows: 4,
        maxRows: 8
      }
    },
    model: {
      value: (_vm.formItem.productDescribe),
      callback: function($$v) {
        _vm.$set(_vm.formItem, "productDescribe", $$v)
      },
      expression: "formItem.productDescribe"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("展示视频")]), _vm._v(" "), _c('Col', {
    attrs: {
      "span": "15"
    }
  }, [_c('video', {
    staticStyle: {
      "max-height": "300px"
    },
    attrs: {
      "controls": "controls",
      "src": _vm.formItem.playerSrc
    }
  })])], 1)], 1), _vm._v(" "), _c('formItem', [_c('Row', [_c('Col', {
    staticClass: "formItemTitle",
    attrs: {
      "span": "4"
    }
  }, [_vm._v("展示图片")]), _vm._v(" "), _c('Col', {
    staticClass: "formItemShow",
    attrs: {
      "span": "15"
    }
  }, _vm._l((_vm.imgList), function(item) {
    return _c('div', {
      staticClass: "showImg"
    }, [_c('img', {
      staticStyle: {
        "width": "200px",
        "height": "300px"
      },
      attrs: {
        "src": item
      }
    })])
  }), 0)], 1)], 1), _vm._v(" "), _c('formItem', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.editAppDetail(_vm.formItem.areaId, _vm.sortOrder)
      }
    }
  }, [_vm._v("更新版本")])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e738511","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--1-1!./src/components/app-blocks/webAppDetail.vue
// module id = caS/
// module chunks = 0